import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faClose,
  faPhone,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import "../style/Header.css";
import logo from "../images/Lamaan-logo.png";
import { faFacebookF, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import logofblack from "../images/logo-filled-black.png";
import logofturquoise from "../images/logo-filled-turquoise.png";
import wtspblack from "../images/wtsp-black.png";
import wtspt from "../images/wtsp-turquoise.png";
import instaB from "../images/insta-black.png";
import instaT from "../images/insta-turquoise.png";
import { useMediaQuery } from "react-responsive";
import { config } from "../config";

const Header = () => {
  const location = useLocation();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [imghover, setImgHover] = useState(false);
  const [Wimghover, setWImgHover] = useState(false);
  const [Iimghover, setIImgHover] = useState(false);
  const [isAboutSubmenuOpen, setIsAboutSubmenuOpen] = useState(false);
  const [isServicesSubmenuOpen, setIsServicesSubmenuOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const toggleAboutSubmenu = () => {
    setIsAboutSubmenuOpen(!isAboutSubmenuOpen);
  };

  const toggleServicesSubmenu = () => {
    setIsServicesSubmenuOpen(!isServicesSubmenuOpen);
  };

  const getCurrentPath = () => window.location.pathname + window.location.hash;
  const isActiveLink = (path) => getCurrentPath() === path;
  const cleanedNumber = config.number_1.replace(/\s+/g, "");

  const getHashScrollTarget = (id) => {
    if (id === "contact") {
      return (
        document.querySelector("#contact .form-container") ||
        document.querySelector("#contact .contact-form-container") ||
        document.getElementById(id)
      );
    }

    return document.getElementById(id);
  };

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        const element = getHashScrollTarget(id);
        if (element) {
          const elementRect = element.getBoundingClientRect();
          const absoluteTop = elementRect.top + window.scrollY;

          const headerOffset = 100;
          const centeredScrollTop =
            absoluteTop - (window.innerHeight / 2 - elementRect.height / 2);

          const top =
            id === "contact"
              ? Math.max(centeredScrollTop, 0)
              : Math.max(absoluteTop - headerOffset, 0);

          window.scrollTo({
            top,
            behavior: "smooth",
          });
        }
      }, 500);
    }
  }, [location]);

  return (
    <>
      <header className="header fixed-top">
        {!isMobile && (
          <div className="header-social">
            <div className="social-circle">
              <a
                href={`https://wa.me/${cleanedNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <img
                  src={Wimghover ? wtspt : wtspblack}
                  alt=""
                  style={{
                    width: "2.2rem",
                    height: "2.2rem",
                  }}
                  onMouseEnter={() => setWImgHover(true)}
                  onMouseLeave={() => setWImgHover(false)}
                />
              </a>
            </div>
            <div className="social-circle">
              <a
                href={`${config.facebook_1}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <FontAwesomeIcon
                  icon={faFacebookF}
                  style={{
                    fontSize: "1.5rem",
                  }}
                />
              </a>
            </div>
            <div className="social-circle">
              <a
                href={config.insta_1}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <img
                  src={Iimghover ? instaT : instaB}
                  alt=""
                  style={{
                    width: "2rem",
                    height: "2rem",
                  }}
                  onMouseEnter={() => setIImgHover(true)}
                  onMouseLeave={() => setIImgHover(false)}
                />
              </a>
            </div>
            <div className="social-circle">
              <a
                href={`https://linkedin.com/in/dr-maan-abadi-5a3a5283`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <FontAwesomeIcon
                  icon={faLinkedinIn}
                  style={{
                    fontSize: "1.7rem",
                  }}
                />
              </a>
            </div>
            <div className="social-circle">
              <a
                href={`${config.healthflow}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <img
                  src={imghover ? logofturquoise : logofblack}
                  alt=""
                  style={{
                    width: "2.1rem",
                    height: "2.1rem",
                  }}
                  onMouseEnter={() => setImgHover(true)}
                  onMouseLeave={() => setImgHover(false)}
                />
              </a>
            </div>
          </div>
        )}
        <div className="container">
          <a href="/" className="logo">
            <img
              src={logo}
              alt=""
              style={{
                // width: "4.5rem",
                // height: "4.5rem",
                width: "15.6rem",
                height: "7.8rem",
                marginRight: "1rem",
              }}
            />
            {/* Health<span>Flow</span> */}
          </a>
          <nav className="nav">
            <a href="/" className={isActiveLink("/#home") ? "active" : ""}>
              home
            </a>
            <div className="nav-submenu">
              {config.aboutSection && (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a
                  href="/More"
                  className={isActiveLink("/More") ? "active" : ""}
                >
                  Aligners
                </a>
              )}
              <div className="submenu-items">
                <a href="/More#tabs-section">Process Steps</a>
                <a href="/More#aligner-specs">Material Specs</a>
              </div>
            </div>
            <a
              href="/Pricing"
              className={isActiveLink("/Pricing") ? "active" : ""}
            >
              pricing
            </a>
            <div className="nav-submenu">
              <a
                href="/Results"
                className={isActiveLink("/Results") ? "active" : ""}
                onClick={() => setIsDrawerOpen(false)}
              >
                Essentials
              </a>
              <div className="submenu-items">
                <a href="/Results#results-section">Treatment Results</a>
                <a href="/Results#care-section">Care Instructions</a>
                <a href="/Results#tips-section">General Tips </a>
              </div>
            </div>
            <a href="/FAQS" className={isActiveLink("/FAQS") ? "active" : ""}>
              FAQs
            </a>
            <a
              href="/for-doctors"
              className={`${
                isActiveLink("/for-doctors") ? "active" : ""
              } fordentist-link`}
            >
              For Dentists
            </a>

            <div
              id="call-block"
              onClick={() => {
                window.location.href = `tel:${config.number_1}`;
              }}
              style={{
                cursor: "pointer",
              }}
            >
              <div id="phone-btn">
                <FontAwesomeIcon icon={faPhone} />
              </div>
              <div>
                <h2>Call Us</h2>
                <h2>03 640 520</h2>
              </div>
              <a
                href={
                  window.location.pathname === "/for-doctors"
                    ? "/for-doctors/#doctor-contact"
                    : "/#contact"
                }
                className="link-btn"
              >
                {window.location.pathname === "/for-doctors"
                  ? "Become a Partner"
                  : "Get in Touch"}
              </a>
            </div>
          </nav>
          {isDrawerOpen ? (
            <div
              id="close-btn"
              onClick={toggleDrawer}
              style={{
                marginTop: "1rem",
                marginRight: "0.2rem",
              }}
            >
              <FontAwesomeIcon icon={faClose} />
            </div>
          ) : (
            <div id="menu-btn" onClick={toggleDrawer}>
              <FontAwesomeIcon icon={faBars} />
            </div>
          )}
        </div>
        <div className={`drawer ${isDrawerOpen ? "open" : ""}`}>
          <a href="#home" className="logo-drawer">
            <img
              src={logo}
              alt=""
              style={{
                // width: "4.5rem",
                // height: "4.5rem",
                width: "15rem",
                height: "7.5rem",
                marginRight: "1rem",
              }}
            />
            {/* LA<span>MAAN</span> */}
          </a>
          <nav className="drawer-nav">
            <a
              href="/#home"
              className={isActiveLink("/#home") ? "active" : ""}
              onClick={() => setIsDrawerOpen(false)}
            >
              home
            </a>
            <div className="submenu-mobile">
              {config.aboutSection && (
                <div className="submenu-header">
                  <a
                    style={{
                      marginBottom: "0rem",
                      marginTop: "0rem",
                    }}
                    href="/More"
                    className={isActiveLink("/More") ? "active" : ""}
                  >
                    Aligners
                  </a>
                  <FontAwesomeIcon
                    icon={isAboutSubmenuOpen ? faChevronUp : faChevronDown}
                    onClick={toggleAboutSubmenu}
                    className="submenu-toggle"
                  />
                </div>
              )}
              {isAboutSubmenuOpen && (
                <div
                  className={`submenu-items-mobile ${
                    isAboutSubmenuOpen ? "open" : ""
                  }`}
                >
                  <a href="/More#tabs-section">Process Steps</a>
                  <a href="/More#aligner-specs">Material Specs</a>
                </div>
              )}
            </div>
            <a
              href="/Pricing"
              className={isActiveLink("/Pricing") ? "active" : ""}
            >
              pricing
            </a>
            <div className="submenu-mobile">
              <div className="submenu-header">
                <a
                  href="/Results"
                  className={isActiveLink("/Results") ? "active" : ""}
                  onClick={() => setIsDrawerOpen(false)}
                >
                  Essentials
                </a>
                <FontAwesomeIcon
                  icon={isServicesSubmenuOpen ? faChevronUp : faChevronDown}
                  onClick={toggleServicesSubmenu}
                  className="submenu-toggle"
                />
              </div>
              {isServicesSubmenuOpen && (
                <div
                  className={`submenu-items-mobile ${
                    isServicesSubmenuOpen ? "open" : ""
                  }`}
                >
                  <a href="/Results#results-section">Treatment Results</a>
                  <a href="/Results#care-section">Care Instructions</a>
                  <a href="/Results#tips-section">General Tips</a>
                </div>
              )}
            </div>
            <a href="/FAQS" className={isActiveLink("/FAQS") ? "active" : ""}>
              FAQs
            </a>
            <a
              href="/for-doctors"
              className={`${
                isActiveLink("/for-doctors") ? "active" : ""
              } fordentist-link`}
            >
              For Dentists
            </a>
          </nav>
          <div
            style={{
              width: "100%",
              marginTop: "auto",
            }}
          >
            <div id="mobile-call-block">
              <div id="phone-btn">
                <FontAwesomeIcon icon={faPhone} />
              </div>
              <div>
                <a
                  href={`tel:${config.number_1}`}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  <h2>Call Us</h2>
                  <h2 className="drawer-mobile-number">{config.number_1}</h2>
                </a>
              </div>
              <a href="/#contact" className="link-btn">
                {window.location.pathname === "/for-doctors"
                  ? "Become a Partner"
                  : "Get in Touch"}
              </a>
            </div>
            <a
              href="/#contact"
              className="mobile-link-btn"
              style={{
                display: "block",
                textAlign: "center",
                fontSize: "2rem",
                padding: "2rem",
              }}
              onClick={toggleDrawer}
            >
              {window.location.pathname === "/for-doctors"
                ? "Become a Partner"
                : "Get in Touch"}
            </a>
            <div className="mobile-header-social">
              <div className="social-circle">
                <a
                  href={`https://wa.me/${cleanedNumber}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={Wimghover ? wtspt : wtspblack}
                    alt=""
                    style={{
                      width: "3rem",
                      height: "3rem",
                    }}
                    onMouseEnter={() => setWImgHover(true)}
                    onMouseLeave={() => setWImgHover(false)}
                  />
                </a>
              </div>
              <div className="social-circle">
                <a
                  href={`${config.facebook_1}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faFacebookF}
                    style={{
                      fontSize: "2.5rem",
                    }}
                  />
                </a>
              </div>
              <div className="social-circle">
                <a
                  href={config.insta_1}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  <img
                    src={Iimghover ? instaT : instaB}
                    alt=""
                    style={{
                      width: "3rem",
                      height: "3rem",
                      marginTop: "0.2rem",
                    }}
                    onMouseEnter={() => setIImgHover(true)}
                    onMouseLeave={() => setIImgHover(false)}
                  />
                </a>
              </div>
              <div className="social-circle">
                <a
                  href={`https://linkedin.com/in/dr-maan-abadi-5a3a5283`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faLinkedinIn}
                    style={{
                      fontSize: "3rem",
                    }}
                  />
                </a>
              </div>
              <div className="social-circle">
                <a
                  href={`${config.healthflow}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  <img
                    src={imghover ? logofturquoise : logofblack}
                    alt=""
                    style={{
                      width: "3.1rem",
                      height: "3.1rem",
                    }}
                    onMouseEnter={() => setImgHover(true)}
                    onMouseLeave={() => setImgHover(false)}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
